// @flow weak

// fetchTools:
export {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin,
  encodeBase64
}                             from './fetchTools';
// fetchMocks:
export {
  fetchMockEarningGraphData,
  fetchMockTeamMatesData
}                             from './fetchMocks';
// API:
export {
  getEarningGraphData,
  getTeamMatesData,
  getUserInfoData,
  getStatsWidgetData,
  getStatsCardData,  
  getScoreCardData,    
  getLocationMenuData
}                             from './API';



// WEBPACK FOOTER //
// ./src/app/services/index.js